/**
 * Who can reach which parts of the CRM, as the portal shows it. The API enforces the same rules; these only decide what
 * to show.
 */
import globalStore from "/globalStore.js";




/**
 * Is the CRM workspace on for this user: the CRM.Enabled feature (the account's licence) and the account's module switch
 * (Admin > CRM & Sales).
 */
export function isCrmWorkspaceAvailable()
{
	if (!globalStore.currentUser) return false;

	return globalStore.currentUser.hasFeatureAccess("CRM.Enabled") && globalStore.currentUser.isCrmWorkspaceOn();
}




/**
 * Does this user hold a CRM feature? Account admins and Lotus staff hold them all, as the API treats them.
 */
function hasCrmFeature(featureCode)
{
	const user = globalStore.currentUser;
	if (!user) return false;

	return user.hasFeatureAccess(featureCode)
		|| user.hasFeatureAccess("AccountAdmin.All")
		|| user.hasFeatureAccess("LotusAdministration.All")
		|| user.hasFeatureAccess("LotusDevelopment.All");
}




/**
 * Can this user open Home and the Pipeline? The workspace must be on, and they need View pipeline.
 */
export function canViewPipeline()
{
	return isCrmWorkspaceAvailable() && hasCrmFeature("CRM.ViewPipeline");
}




/**
 * Can this user open Contacts? The workspace must be on, and they need Manage contacts (reading contacts needs it too).
 */
export function canOpenContacts()
{
	return isCrmWorkspaceAvailable() && hasCrmFeature("CRM.ManageContacts");
}




/**
 * Can this user open the Sales & CRM reports? The workspace must be on, and they need View pipeline (account admins and
 * Lotus staff have it implicitly). What each report shows is still limited to the deals their pipeline visibility allows.
 */
export function canOpenSalesReports()
{
	return canViewPipeline();
}
